import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrawer2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDrawer2"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V19H18V22H16V19H8V22H6V19H3V3ZM11 12V17H5V12H11ZM11 10V5H5V10H11ZM16 9V13H14V9H16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDrawer2;
